var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1868 16.1097C23.1868 17.3396 22.6982 18.5191 21.8285 19.3888C20.9589 20.2584 19.7793 20.747 18.5494 20.747C17.3195 20.747 16.14 20.2584 15.2703 19.3888C14.4006 18.5191 13.9121 17.3396 13.9121 16.1097C13.9121 14.8798 14.4006 13.7002 15.2703 12.8305C16.14 11.9609 17.3195 11.4723 18.5494 11.4723C19.7793 11.4723 20.9589 11.9609 21.8285 12.8305C22.6982 13.7002 23.1868 14.8798 23.1868 16.1097Z",
    stroke: "#959595",
    strokeWidth: 2.31868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1428 16.1096C30.1428 27.1496 18.5495 33.4997 18.5495 33.4997C18.5495 33.4997 6.95605 27.1496 6.95605 16.1096C6.95605 13.0349 8.1775 10.086 10.3517 7.91186C12.5259 5.73768 15.4747 4.51624 18.5495 4.51624C21.6242 4.51624 24.573 5.73768 26.7472 7.91186C28.9214 10.086 30.1428 13.0349 30.1428 16.1096Z",
    stroke: "#959595",
    strokeWidth: 2.31868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact4);
export default __webpack_public_path__ + "static/media/contact4.9acc0879fdda8edb6e6685a040e36d7c.svg";
export { ForwardRef as ReactComponent };